import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { readingConfig } from "./data";

export default function ReadingPage() {
  return <CityPageTemplate config={readingConfig} />;
}